import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../features/auth/contexts/AuthContext';
import { LoadingSpinner } from '../shared/components';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, initialized, isLoading } = useAuth();
  const navigate = useNavigate();


  useEffect(() => {
    if (initialized && !isLoading && !isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, initialized, isLoading, navigate]);

  // Also redirect immediately if conditions are met (not waiting for useEffect)
  if (initialized && !isLoading && !isAuthenticated) {
    navigate('/', { replace: true });
    return null;
  }

  // Show loading while initializing
  if (!initialized || isLoading) {
    return <LoadingSpinner overlay message="Checking authentication..." />;
  }

  // If not authenticated, don't render anything (redirect will happen)
  if (!isAuthenticated) {
    return null;
  }

  // If authenticated, render the protected content
  return <>{children}</>;
};

export default ProtectedRoute;